import React from 'react'
import { sidebarApps } from '@/test_data/sidebar-data'
import { MiniAppText } from '@/ui/molecules/mini-app-text'
import { MiniAppProps } from './types'
import { useTabData } from '@sourcepilot/ui/framework/state/session-data';

export function ComponentSearchMiniApp({ containerWidth }: MiniAppProps) {
  const [hoveredItem, setHoveredItem] = React.useState<string | null>(null);
  const { activeTab, navigateToTab } = useTabData();

  const componentSearch = (sidebarApps.find(app => app.label === 'Component Search') as any)?.items || []

  return (
    <div className="px-4">
      <ul className="p-0 list-none">
        {componentSearch.map((item: any) => (
          <li key={item.pathname} className="p-auto m-auto leading-none">
            <button 
              className="text-left hover:underline w-full"
              onClick={() => navigateToTab(item)}
              onMouseEnter={() => setHoveredItem(item.pathname)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <MiniAppText 
                className="text-sm" 
                containerWidth={containerWidth - 32}
                isActive={item.pathname === activeTab?.pathname}
                isHovered={item.pathname === hoveredItem}
              >
                {item.title}
              </MiniAppText>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

